<div>
    <div *ngIf="noSearchForms">
        No search forms to be displayed
    </div>
    <mat-sidenav-container [hasBackdrop]="false" autosize>
        <mat-sidenav #sidenav mode="side" opened style="display: block;">

            <div>
                <div class="heading"> Available Search Forms
                </div>
                <div class="input-group-sm mt-2 input-group col-12">
                    <input class="form-control" type="search" (keyup)="applyFilterSideNav($event)"
                        (search)="applyFilterSideNav($event)" placeholder="Filter">
                    <!-- <mat-icon *ngIf = "filterValue" (click)="document.getElementById('filterInput').value = ''">close</mat-icon> -->
                </div>
                <mat-nav-list>
                    <div *ngFor="let searchForm of navBarForms">
                        <a *ngIf="searchForm.id != 13" style="height: 30px;" mat-list-item
                            (click)="getForm($event, searchForm.id)">
                            <button  mat-button style="font-size: 11pt; height: 30px; "
                                [ngStyle]="{'font-weight': searchForm === selectedForm ? 'bold' : 'normal' }">{{searchForm.name}}</button>
                        </a>
                    </div>
                </mat-nav-list>
            </div>

        </mat-sidenav>
        <mat-sidenav-content style="margin-right: 0; padding:0; height: calc(100vh - 50px);">

            <div class="container-fluid">
                <!-- Please don't remove this button!!!! -->
                <button type="button" class="mt-1" mat-stroked-button (click)="sidenav.toggle()">
                    <div *ngIf="sidenav.opened">Hide Search Form List</div>
                    <div *ngIf="!sidenav.opened">Show Search Form List</div>
                </button>

                <div class="card mt-1" *ngIf=!selectedForm>
                    <div class="card-body"><strong>Please select a search form</strong><br> 1. To view the documents
                        associated with it.</div>
                </div>

                <!--Search Form-->
                <div class="card bg-light text-dark mt-1"
                    *ngIf=selectedForm>
                    <div class="card-body">
                        <h6 class="card-title">{{selectedForm.name}}</h6>
                        <form #initiateForm="ngForm">
                            <div class="example-box">
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-12 mb-2"
                                        *ngFor="let item of selectedForm.form; index as i; trackBy:trackByIndex;"
                                        title="{{selectedForm.form[i].helpText}}">
                                        <div class="input-group input-group-sm">
                                            <div *ngIf="item.UIControl != 'Static'" class="input-group-prepend">
                                                <div class="input-group-text form-label-fixed">{{item.label}} {{item.operator}}
                                                </div>
                                            </div>
                                            <input *ngIf="!item.required && item.UIControl == 'InputText'"
                                                class="form-control" name="{{'name'+i}}"
                                                [(ngModel)]="selectedForm.form[i].values" placeholder="{{item.helpText}}"
                                                type="text">
                                            <input *ngIf="!item.required && item.UIControl == 'Date'"
                                                class="form-control" name="{{'name'+i}}"
                                                [(ngModel)]="selectedForm.form[i].values" placeholder="{{item.helpText}}"
                                                type="date">
                                            <input *ngIf="item.required && item.UIControl == 'InputText'"
                                                class="form-control" name="{{'name'+i}}"
                                                [(ngModel)]="selectedForm.form[i].values" placeholder="{{item.helpText}}*"
                                                type="text" required>
                                            <input *ngIf="item.required && item.UIControl == 'Date'"
                                                class="form-control" name="{{'name'+i}}"
                                                [(ngModel)]="selectedForm.form[i].values" placeholder="{{item.helpText}}*"
                                                type="date" required>
                                            <mat-select style="font-size: 90%;"
                                                *ngIf="item.required && item.UIControl == 'Dynamic'" name="{{'name'+i}}"
                                                class="form-control" [(ngModel)]="selectedForm.form[i].values"
                                                placeholder="{{item.helpText}}*" required>
                                                <mat-option style="font-size: 90%;">
                                                    <ngx-mat-select-search [(ngModel)]="searchCtrl"
                                                        [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'"
                                                        name="search" ngDefaultControl [ngModelOptions]="{standalone: true}">
                                                    </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option style="font-size: 90%;"
                                                    *ngFor="let value of dynamicValues[selectedForm.form[i].attribute]|stringFilter:searchCtrl:'value'"
                                                    [value]="value">
                                                    {{value}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-select style="font-size: 90%;"
                                                *ngIf="!item.required && item.UIControl == 'Dynamic'" name="{{'name'+i}}"
                                                class="form-control" [(ngModel)]="selectedForm.form[i].values"
                                                placeholder="{{item.helpText}}">
                                                <mat-option style="font-size: 90%;">
                                                    <ngx-mat-select-search [(ngModel)]="searchCtrl"
                                                        [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'"
                                                        name="search" ngDefaultControl [ngModelOptions]="{standalone: true}">
                                                    </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option style="font-size: 90%;"
                                                    *ngFor="let value of dynamicValues[selectedForm.form[i].attribute]|stringFilter:searchCtrl:'value'"
                                                    [value]="value">
                                                    {{value}}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-12">
                                        <div class="input-group input-group-sm mb-1">
                                            <div class="input-group-prepend"><div class="input-group-text form-label-fixed">Case Insensitive Search:</div></div>
                                            <mat-slide-toggle class="pl-2 pr-2 pt-1" name = "case-insensitive-toggle"  [(ngModel)]="isCaseInsensitive"></mat-slide-toggle>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="row" *ngIf="archive">
                                    <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text form-label-fixed">Archived:</div>
                                            </div>
                                            <mat-slide-toggle class="pl-2 pr-2 pt-1" name="archived-toggle"
                                                [(ngModel)]="showArchived"></mat-slide-toggle>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="selectedForm.id == '10' || selectedForm.id == '11'">
                                    <div class="col-lg-4 col-md-6 col-sm-12 mb-2" title="Enter County (comma-separated)">
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text form-label-fixed">County IN
                                                </div>
                                            </div>
                                            <input class="form-control" name="County" [(ngModel)]="counties" placeholder="Enter County (comma-separated)" type="text">
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-12">
                                        <button type="submit" mat-raised-button (click)="executeSearch($event, sidenav)"
                                            class="float-right" [disabled]="!initiateForm.valid">Search</button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
                <!-- End Search Form -->
            </div>


            <div class="container-fluid">
                <div style="margin-top: 1em;" *ngIf="noSearchResults">
                    <strong> No results to be displayed</strong>
                    <div style="float:right">
                        (Total Count: {{totalDoc}})
                    </div>
                </div>
                <div style="margin-top: 1em;" *ngIf="searchResults.length > 0">
                    <mat-paginator [pageSizeOptions]="[50, 100]" [pageSize]="50" (page)="selectPage($event)" class="custom-paginator" showFirstLastButtons>
                    </mat-paginator>
                </div>

                <div class="row" *ngIf="searchResults.length > 0" id="searchResults">
                    <div class="col" *ngIf="!hideDocList">
                       <div class="filtercontainer" style="margin-bottom: 1em;">
                            <span *ngIf="selection.selected.length>0 && showArchived">
                                <button style="margin-bottom: 2px;" mat-raised-button
                                    (click)="retrieveGlacierDocuments()"> Initiate Restore
                                </button>
                            </span>
                            <!-- Export option - Uncomment for MCR -->
                            <span *ngIf="selection.selected.length>0">
                                <button class="uploadbutton" style="margin-bottom: 2px;" mat-raised-button
                                    (click)="exportDocuments()">
                                    <mat-icon>cloud_download</mat-icon> Export Documents
                                </button>
                            </span>
                            <div style="float:right;margin-top: 1em;">
                                (Total Count: {{totalDoc | number}})
                            </div>
                       </div>
                       <div class="row" style="margin-bottom: 1em; margin-left: 1em; text-align: left;">
                            <span *ngIf="selection.selected.length>0">
                                <div>
                                    <a href="javascript:void(0)" (click)="isExportMetaDataCsv=true">Show Export Metadata CSV</a>
                                </div>
                                <div>
                                    <span *ngIf="isExportMetaDataCsv">
                                        <label >Enter the expiration time (in Mins - Max upto 480 mins): </label><input type="number" [(ngModel)]="exportExpiration" />&nbsp;
                                        <button [disabled]="exportExpiration == null || exportExpiration <= 0 || exportExpiration > 480" class="uploadbutton" style="margin-bottom: 2px;" mat-raised-button
                                                (click)="exportDocumentLink()">
                                            <mat-icon>cloud_download</mat-icon> Export Metadata CSV
                                        </button>
                                        <div *ngIf="exportExpiration <= 0 || exportExpiration > 480" style="color: red; padding-top: 0.2rem">
                                            Please enter the valid expiration time. Expiration time should not exceed 480 mins
                                        </div>
                                    </span>
                                </div>
                            </span>
                       </div>
                      <!-- Filter for search results -->
                       <mat-form-field style="margin-left: 1em;">
                            <mat-label>Filter</mat-label>
                            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. John">
                        </mat-form-field>
                        <div class="row" style="margin-bottom: 1em;">
                            <div class="col-2">
                                <button mat-button [matMenuTriggerFor]="menu">
                                    Show/Hide Columns
                                    <mat-menu #menu="matMenu">
                                      <span class="table-config-menu-label">Edit Columns</span>
                                      <div class="table-config-menu-options">
                                        <mat-checkbox
                                          *ngFor="let cd of selectedFormDisplayList; let i = index"
                                          (click)="$event.stopPropagation()"
                                          [(ngModel)]="cd.visible">
                                          {{cd.name}}
                                        </mat-checkbox>
                                        <button (click)="applyShowHideColumns()">Apply</button>
                                      </div>
                                  </mat-menu>
                                </button>
                            </div>
                        </div>
                        <div class="mat-elevation-z8" *ngIf="searchResults.length > 0">
                            <table mat-table [dataSource]="searchResultsList" matSort aria-describedby="doc-table">
                                <ng-container matColumnDef="select">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <mat-checkbox #ref (change)="$event ? masterToggle(ref) : null"
                                            [checked]="selection.hasValue() && isAllSelected()"
                                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                                        </mat-checkbox>
                                    </th>
                                    <td mat-cell *matCellDef="let row">
                                        <mat-checkbox class="header-checkBox" (click)="$event.stopPropagation()"
                                            (change)="$event ? selection.toggle(row.documentId) : null;isSomeSelected()"
                                            [checked]="selection.isSelected(row.documentId)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>
                                 <!-- dynamic columns -->
                                <ng-container *ngFor="let column of selectedFormDisplayList">
                                    <ng-container  *ngIf = "column.visible && column.type == 'original'"
                                    matColumnDef="{{ column.name }}"
                                    >
                                    <th
                                        id="{{ column.name }}"
                                        mat-header-cell
                                        *matHeaderCellDef
                                        mat-sort-header
                                    >
                                        {{ column.name  }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element)" >
                                        {{ element[column.value] }}
                                    </td>
                                    </ng-container>
                                    <ng-container  *ngIf = "column.visible && column.type == 'properties' && column.data_type == 'object'"
                                    matColumnDef="{{ column.name }}"
                                    >
                                    <th
                                        id="{{ column.name }}"
                                        mat-header-cell
                                        *matHeaderCellDef
                                        mat-sort-header
                                    >
                                        {{ column.name  }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element)" >
                                        {{ element.meta_data.properties[column.value] | json}}
                                    </td>
                                    </ng-container>
                                    <ng-container  *ngIf = "column.visible && column.type == 'properties' && column.data_type != 'object'"
                                    matColumnDef="{{ column.name }}"
                                    >
                                    <th
                                        id="{{ column.name }}"
                                        mat-header-cell
                                        *matHeaderCellDef
                                        mat-sort-header
                                    >
                                        {{ column.name  }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element)" >
                                        {{ element.meta_data.properties[column.value] }}
                                    </td>
                                    </ng-container>
                                    <ng-container  *ngIf = "column.visible && column.type == 'system'"
                                    matColumnDef="{{ column.name }}"
                                    >
                                    <th
                                        id="{{ column.name }}"
                                        mat-header-cell
                                        *matHeaderCellDef
                                        mat-sort-header
                                    >
                                        {{ column.name  }}
                                    </th>
                                    <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element)" >
                                        {{ element.meta_data.system[column.value] }}
                                    </td>
                                    </ng-container>
                                </ng-container>
                                <!-- end dynamic columns-->
                                <ng-container matColumnDef="actionButton">
                                    <th id="actionButton" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-button [matMenuTriggerFor]="menu" (click)="subscribe(element)">
                                            <mat-icon>list</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item (click)="openUpdateMetaData()" [disabled]="isDocLocked">Update
                                                Metadata</button>
                                            <button mat-menu-item (click)="openUploadDocument()" [disabled]="isDocLocked">Upload
                                                Version</button>
                                            <button mat-menu-item (click)="lockUnlockDocument(activeDocumentDetails.locked)">
                                                <div *ngIf=isDocLocked>Unlock Document</div>
                                                <div *ngIf=!isDocLocked>Lock Document</div>
                                            </button>
                                        </mat-menu>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="searchResultsCols"></tr>
                                <tr mat-row *matRowDef="let row; columns: searchResultsCols;"
                                    class="element-row"
                                    [class.selected-row]="selectedRow === row"
                                    (click)="selectedRow = selectedRow === row ? null : row">
                                </tr>
                            </table>
                            <!-- <div *ngIf="loadNext" class="loadButton mb-4">
                                <button mat-raised-button (click)=next(sidenav)>Next 200<mat-icon>keyboard_arrow_right
                                    </mat-icon></button>
                            </div>
                            <div *ngIf="loadPrevious" class="loadButton mb-4">
                                <button mat-raised-button (click)=previous(sidenav)>
                                    <mat-icon>keyboard_arrow_left</mat-icon>Previous 200
                                </button>
                            </div> -->

                        </div>
                    </div>
                    <div class="col-4" *ngIf="openVersionUpload">
                        <app-dialog-upload [documentDetails]="activeDocumentDetails" (close)="closeTabs($event)"
                            (openUpload)="backFromUpload($event)">
                        </app-dialog-upload>
                    </div>
                    <div class="col-4" *ngIf="openMetaData">
                        <app-dialog-update [document]="activeDocumentDetails" (close)="closeTabs($event)"
                            (openMetaData)="backFromMetaData($event)">
                        </app-dialog-update>
                    </div>
                    <div class="col" *ngIf="selectedDoc && hideDocList">
                        <app-display-search-doc [selectedDocument]="selectedDoc.documentId"
                            [searchResultsList]="searchResultsList" (hideDocList)="onHideDocList($event,sidenav)">
                        </app-display-search-doc>
                    </div>
                </div>
            </div>

        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
